import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';



import { FileUtil } from 'rev-shared/util/FileUtil';
import { IRules } from 'rev-shared/ui/css/CssRules.Contract';

import { BrandingSettings } from 'rev-portal/branding/BrandingSettings.Contract';
import { ThemeService } from 'rev-portal/branding/Theme.Service';

import styles from './video-supplemental-content.module.less';

@Component({
	selector: 'video-supplemental-content',
	templateUrl: './VideoSupplementalContent.Component.html'
})
export class VideoSupplementalContentComponent implements OnInit, OnDestroy {
	@Input() public supplementalContents: any;

	public readonly styles = styles;
	public themeServiceSub: Subscription;
	public themeStyleOverrides: IRules;

	constructor(
		private ThemeService: ThemeService
	) { }

	public ngOnInit(): void {
		this.themeServiceSub = this.ThemeService.brandingSettings$.subscribe(brandingSettings => this.applyCssRules(brandingSettings));
	}

	public ngOnDestroy(): void {
		this.themeServiceSub?.unsubscribe();
	}

	public applyCssRules(brandingSettings: BrandingSettings): void {
		const themeAccentColor = brandingSettings.themeSettings.accentColor;
		const themeAccentFontColor = brandingSettings.themeSettings.accentFontColor;
		this.themeStyleOverrides = {
			[`
				.${styles.item}:hover:not([disabled]) .${styles.fileName},
				.${styles.item}:hover:not([disabled]):after
			`]: {
				'background-color': themeAccentColor,
				'color': themeAccentFontColor,
				'text-decoration': 'none'
			}
		};
	}

	public getFileExtensionClass(extension: string): string {
		return FileUtil.getFileExtensionCssClass(extension);
	}
}
